import { Spin } from 'antd';

import * as Styles from './MSpinner.styles';

interface SpinnerProps {
  height?: string;
}

export const MSpinner = ({ height }: SpinnerProps) => {
  return <Spin className={Styles.container(height ?? '70vh')} />;
};
